var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_547_964)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0246 17.0773C17.9114 17.0854 17.3269 17.1189 16.0231 17.1189C14.9861 17.1189 14.2498 17.0891 13.9914 17.0773C9.98379 16.9084 6.99242 16.2401 6.99242 15.4399C6.99242 14.6398 9.98379 13.9724 13.9914 13.8008V16.4117C14.2535 16.4298 15.004 16.4722 16.041 16.4722C17.2854 16.4722 17.9086 16.4225 18.0208 16.4126V13.8026C22.02 13.9733 25.0047 14.6416 25.0047 15.4399C25.0047 16.2383 22.0209 16.9066 18.0208 17.0764L18.0246 17.0773ZM18.0246 13.5325V11.1961H23.6057V7.6333H8.41033V11.1961H13.9905V13.5316C9.4549 13.7312 6.04401 14.5919 6.04401 15.6233C6.04401 16.6546 9.4549 17.5144 13.9905 17.7149V25.2019H18.0236V17.7122C22.5489 17.5126 25.9541 16.6528 25.9541 15.6224C25.9541 14.5919 22.5517 13.7321 18.0236 13.5316L18.0246 13.5325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.f0aa6eb2.svg";
export { ForwardRef as ReactComponent };